module.exports = __webpack_public_path__ + "static/media/view4.07f963a4.jpg";